import { render } from "./ProductPrice.vue?vue&type=template&id=9f2ab7cc&scoped=true"
import script from "./ProductPrice.vue?vue&type=script&lang=js"
export * from "./ProductPrice.vue?vue&type=script&lang=js"

import "./ProductPrice.vue?vue&type=style&index=0&id=9f2ab7cc&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f2ab7cc"]])

export default __exports__